import { useSubscription } from '@apollo/client';
import { Trans, msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { setSnackbar } from 'src/slices/components';
import { useDispatch } from 'src/store';
import DATA_EXTRACTION_SUBSCRIPTION from '../graphql/subscription/dataExtractionSubscription';

const CreatedReportNotification = () => {
  const dispach = useDispatch();
  const { _ } = useLingui();

  const [state, setState] = useState({ show: false, title: '', message: '' });

  const { data } = useSubscription(DATA_EXTRACTION_SUBSCRIPTION, {
    onData: (options) => {
      const { data: dataResponse } = options.data;
      if (dataResponse == null) {
        return;
      }
      const { reportCreated } = dataResponse;
      if (reportCreated == null) {
        return;
      }
      const { success, message } = reportCreated;
      if (success) {
        setState({
          show: true,
          title: _(msg`Reporte creado exitosamente`),
          message: _(
            msg`Se ha creado el reporte con éxito y ha sido enviado a los correos electrónicos seleccionados. Por favor, revise su bandeja de entrada.`,
          ),
        });
        return;
      }
      dispach(
        setSnackbar({
          open: true,
          message: message ?? _(msg`No se ha podido completar la creación de reporte.`),
          severity: 'error',
        }),
      );
    },
  });

  const handleClose = () => setState({ show: false, title: '', message: '' });

  const { reportCreated } = data ?? {};
  const { urlPdf, urlExcel, devices } = reportCreated ?? {};

  return (
    <Dialog open={state.show} onClose={handleClose}>
      <DialogTitle>{state.title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>{state.message}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                mb: 2,
              }}
            >
              <Trans>Puedes descargar el reporte desde los siguientes enlaces</Trans>
            </Typography>
          </Grid>
          <Grid item container spacing={2} my={2} p={2}>
            {(devices ?? []).map((d, index) => (
              <Box
                justifyContent="space-between"
                alignContent="center"
                width="100%"
                key={index}
                px={3}
              >
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography>{d?.id}</Typography>
                  <Typography>{d?.profile.name}</Typography>
                  <Typography>{d?.profile.type}</Typography>
                </Box>
              </Box>
            ))}
          </Grid>
          {urlExcel && (
            <Grid item xs={6} px={2}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                onClick={() => window.open(urlExcel)}
              >
                <Trans>Descargar Excel</Trans>
              </Button>
            </Grid>
          )}
          {urlPdf && (
            <Grid item xs={6} px={2}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                onClick={() => window.open(urlPdf)}
              >
                <Trans>Descargar PDF</Trans>
              </Button>
            </Grid>
          )}
          <Grid item container justifyContent="flex-end">
            <Button variant="outlined" color="primary" onClick={handleClose}>
              <Trans>Cerrar</Trans>
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CreatedReportNotification;
